import { isUrl } from 'utils/urls';
import { LinkElement } from './LinkElement';

export const linkPlugin = {
  options: {
    isUrl,
  },
  serializeHtml: LinkElement,
};